import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'moment',
  pure: false,
  standalone:true
})
export class MomentPipe implements PipeTransform {

  transform(m: moment.Moment, format: string = 'MMMM YYYY'): string {
    return m.format(format);
  }

}
